import axios from 'axios';
import {BaseResponse} from "./BaseResponse";
import {getLocalStorageJsonItemOrNull} from "../lib/getLocalStorageItemOrNull";
import {LOCAL_STORAGE_KEY_TOKEN} from "../resources/LocalStorageConstants";

export async function refreshToken() {
    const erpToken = getLocalStorageJsonItemOrNull(LOCAL_STORAGE_KEY_TOKEN)
    console.log("refreshToken api 진입")
    const response = await axios.get<BaseResponse<ErpToken>>(`/token/refresh`, {
        headers: {
            'Authorization': `Bearer ${erpToken.refreshToken}`
        }
    })
    console.log("refreshToken api  : " + response)

    return response.data
}

export interface ErpToken {
    accessToken: string,
    refreshToken: string
}